import { createAction } from 'redux-act';
// add Department action
const addDepartmentRequest = createAction('ADD_DEPARTMENT_REQUEST', data => data);
const addDepartmentSuccess = createAction('ADD_DEPARTMENT_SUCCESS', data => data);
const addDepartmentError = createAction('ADD_DEPARTMENT_ERROR');

// get Sub Department action
const getAllDepartmentRequest = createAction('GET_ALL_DEPARTMENT_REQUEST', data => data);
const getAllDepartmentSuccess = createAction('GET_ALL_DEPARTMENT_SUCCESS', data => data);
const getAllDepartmentError = createAction('GET_ALL_DEPARTMENT_ERROR');
// get Department list
const getDepartmentListRequest = createAction('GET_DEPARTMENT_LIST_REQUEST', data => data);
const getDepartmentListSuccess = createAction('GET_DEPARTMENT_LIST_SUCCESS', data => data);
const getDepartmentListError = createAction('GET_DEPARTMENT_LIST_ERROR');

// Update Department action
const updateDepartmentRequest = createAction('Update_DEPARTMENT_REQUEST', data => data);
const updateDepartmentSuccess = createAction('Update_DEPARTMENT_SUCCESS', data => data);
const updateDepartmentError = createAction('Update_DEPARTMENT_ERROR');

// Delete Department action
const deleteDepartmentRequest = createAction('Delete_DEPARTMENT_REQUEST', data => data);
const deleteDepartmentSuccess = createAction('Delete_DEPARTMENT_SUCCESS', data => data);
const deleteDepartmentError = createAction('Delete_DEPARTMENT_ERROR');

/*create Sub Department action */
const createSubDepartmentRequest = createAction('CREATE_SUB_DEPARTMENT_REQUEST', data => data);
const createSubDepartmentSuccess = createAction('CREATE_SUB_DEPARTMENT_SUCCESS', data => data);
const createSubDepartmentError = createAction('CREATE_SUB_DEPARTMENT_ERROR');

// get Department action
const getSubDepartmentRequest = createAction('GET_SUB_DEPARTMENT_REQUEST', data => data);
const getSubDepartmentSuccess = createAction('GET_SUB_DEPARTMENT_SUCCESS', data => data);
const getSubDepartmentError = createAction('GET_SUB_DEPARTMENT_ERROR');

// get All Sub Department list
const getAllSubDepartmentListRequest = createAction('GET_ALL_SUB_DEPARTMENT_LIST_REQUEST', data => data);
const getAllSubDepartmentListSuccess = createAction('GET_ALL_SUB_DEPARTMENT_LIST_SUCCESS', data => data);
const getAllSubDepartmentListError = createAction('GET_ALL_SUB_DEPARTMENT_LIST_ERROR');

//get Sub Department By Department
const getSubDepartmentByDepartmentRequest = createAction('GET_GET_SUB_DEPARTMENT_BY_DEPARTMENT_REQUEST', data => data);
const getSubDepartmentByDepartmentSuccess = createAction('GET_GET_SUB_DEPARTMENT_BY_DEPARTMENT_SUCCESS', data => data);
const getSubDepartmentByDepartmentError = createAction('GET_GET_SUB_DEPARTMENT_BY_DEPARTMENT_ERROR');

// Update Sub Department action
const updateSubDepartmentRequest = createAction('UPDATE_SUB_DEPARTMENT_REQUEST', data => data);
const updateSubDepartmentSuccess = createAction('UPDATE_SUB_DEPARTMENT_SUCCESS', data => data);
const updateSubDepartmentError = createAction('UPDATE_SUB_DEPARTMENT_ERROR');

/* create Project action */
const createProjectRequest = createAction('CREATE_PROJECT_REQUEST', data => data);
const createProjectSuccess = createAction('CREATE_PROJECT_SUCCESS', data => data);
const createProjectError = createAction('CREATE_PROJECT_ERROR');

// get Project action
const getProjectRequest = createAction('GET_PROJECT_REQUEST', data => data);
const getProjectSuccess = createAction('GET_PROJECT_SUCCESS', data => data);
const getProjectError = createAction('GET_PROJECT_ERROR');

// get All Sub Department list
const getAllProjectListRequest = createAction('GET_ALL_PROJECT_LIST_REQUEST', data => data);
const getAllProjectListSuccess = createAction('GET_ALL_PROJECT_LIST_SUCCESS', data => data);
const getAllProjectListError = createAction('GET_ALL_PROJECT_LIST_ERROR');

// Update Sub Department action
const updateProjectRequest = createAction('UPDATE_PROJECT_REQUEST', data => data);
const updateProjectSuccess = createAction('UPDATE_PROJECT_SUCCESS', data => data);
const updateProjectError = createAction('UPDATE_PROJECT_ERROR');

/* create Project action */
const createSkillRequest = createAction('CREATE_SKILL_REQUEST', data => data);
const createSkillSuccess = createAction('CREATE_SKILL_SUCCESS', data => data);
const createSkillError = createAction('CREATE_SKILL_ERROR');

/* get Project action */
const getSkillRequest = createAction('GET_SKILL_REQUEST', data => data);
const getSkillSuccess = createAction('GET_SKILL_SUCCESS', data => data);
const getSkillError = createAction('GET_SKILL_ERROR');

/* get All Skill list */
const getAllSkillListRequest = createAction('GET_ALL_SKILL_LIST_REQUEST', data => data);
const getAllSkillListSuccess = createAction('GET_ALL_SKILL_LIST_SUCCESS', data => data);
const getAllSkillListError = createAction('GET_ALL_SKILL_LIST_ERROR');

/* Update Skill action */
const updateSkillRequest = createAction('UPDATE_SKILL_REQUEST', data => data);
const updateSkillSuccess = createAction('UPDATE_SKILL_SUCCESS', data => data);
const updateSkillError = createAction('UPDATE_SKILL_ERROR');

/*  assign Project action */
const assignProjectRequest = createAction('ASSIGN_PROJECT_REQUEST', data => data);
const assignProjectSuccess = createAction('ASSIGN_PROJECT_SUCCESS', data => data);
const assignProjectError = createAction('ASSIGN_PROJECT_ERROR');

/* get Project action */
const getAssignProjectRequest = createAction('GET_ASSIGN_PROJECT_REQUEST', data => data);
const getAssignProjectSuccess = createAction('GET_ASSIGN_PROJECT_SUCCESS', data => data);
const getAssignProjectError = createAction('GET_ASSIGN_PROJECT_ERROR');

/* get All Skill list */
const assignSkillRequest = createAction('ASSIGN_SKILL_REQUEST', data => data);
const assignSkillSuccess = createAction('ASSIGN_SKILL_SUCCESS', data => data);
const assignSkillError = createAction('ASSIGN_SKILL_ERROR');

/* Update Skill action */
const getAssignSkillRequest = createAction('GET_ASSIGN_SKILL_REQUEST', data => data);
const getAssignSkillSuccess = createAction('GET_ASSIGN_SKILL_SUCCESS', data => data);
const getAssignSkillError = createAction('GET_ASSIGN_SKILL_ERROR');

/* Update Skill action */
const addProjectTypeRequest = createAction('ADD_PROJECT_TYPE_REQUEST', data => data);
const addProjectTypeSuccess = createAction('ADD_PROJECT_TYPE_SUCCESS', data => data);
const addProjectTypeError = createAction('ADD_PROJECT_TYPE_ERROR');

/* Update Skill action */
const updateProjectTypeRequest = createAction('UPDATE_PROJECT_TYPE_REQUEST', data => data);
const updateProjectTypeSuccess = createAction('UPDATE_PROJECT_TYPE_SUCCESS', data => data);
const updateProjectTypeError = createAction('UPDATE_PROJECT_TYPE_ERROR');

/* Update Skill action */
const deleteProjectTypeRequest = createAction('DELETE_PROJECT_TYPE_REQUEST', data => data);
const deleteProjectTypeSuccess = createAction('DELETE_PROJECT_TYPE_SUCCESS', data => data);
const deleteProjectTypeError = createAction('DELETE_PROJECT_TYPE_ERROR');

/* Update Skill action */
const getProjectTypeRequest = createAction('GET_PROJECT_TYPE_REQUEST', data => data);
const getProjectTypeSuccess = createAction('GET_PROJECT_TYPE_SUCCESS', data => data);
const getProjectTypeError = createAction('GET_PROJECT_TYPE_ERROR');

/* Update Skill action */
const getAllProjectTypeListRequest = createAction('GET_ALL_PROJECT_Type_LIST_REQUEST', data => data);
const getAllProjectTypeListSuccess = createAction('GET_ALL_PROJECT_Type_LIST_SUCCESS', data => data);
const getAllProjectTypeListError = createAction('GET_ALL_PROJECT_Type_LIST_ERROR');

/* Update Skill action */
const addProjectCategoryRequest = createAction('ADD_PROJECT_CATEGORY_REQUEST', data => data);
const addProjectCategorySuccess = createAction('ADD_PROJECT_CATEGORY_SUCCESS', data => data);
const addProjectCategoryError = createAction('ADD_PROJECT_CATEGORY_ERROR');

/* Update Skill action */
const updateProjectCategoryRequest = createAction('UPDATE_PROJECT_CATEGORY_REQUEST', data => data);
const updateProjectCategorySuccess = createAction('UPDATE_PROJECT_CATEGORY_SUCCESS', data => data);
const updateProjectCategoryError = createAction('UPDATE_PROJECT_CATEGORY_ERROR');

/* Update Skill action */
const deleteProjectCategoryRequest = createAction('DELETE_PROJECT_CATEGORY_REQUEST', data => data);
const deleteProjectCategorySuccess = createAction('DELETE_PROJECT_CATEGORY_SUCCESS', data => data);
const deleteProjectCategoryError = createAction('DELETE_PROJECT_CATEGORY_ERROR');

/* Update Skill action */
const getProjectCategoryRequest = createAction('GET_PROJECT_CATEGORY_REQUEST', data => data);
const getProjectCategorySuccess = createAction('GET_PROJECT_CATEGORY_SUCCESS', data => data);
const getProjectCategoryError = createAction('GET_PROJECT_CATEGORY_ERROR');

/* Update Skill action */
const getAllProjectCategoryListRequest = createAction('GET_ALL_PROJECT_CATEGORY_LIST_REQUEST', data => data);
const getAllProjectCategoryListSuccess = createAction('GET_ALL_PROJECT_CATEGORY_LIST_SUCCESS', data => data);
const getAllProjectCategoryListError = createAction('GET_ALL_PROJECT_CATEGORY_LIST_ERROR');

/* Update Skill action */
const getMastersCountsRequest = createAction('GET_MASTERS_COUNTS_REQUEST', data => data);
const getMastersCountsSuccess = createAction('GET_MASTERS_COUNTS_SUCCESS', data => data);
const getMastersCountsError = createAction('GET_MASTERS_COUNTS_ERROR');

// clear existing Department action
const handleClearDepartmentStore = createAction('HANDLE_CLEAR_DEPARTMENT_STORE', data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    addDepartmentRequest,
    addDepartmentSuccess,
    addDepartmentError,

    getAllDepartmentRequest,
    getAllDepartmentSuccess,
    getAllDepartmentError,

    getDepartmentListRequest,
    getDepartmentListSuccess,
    getDepartmentListError,

    updateDepartmentRequest,
    updateDepartmentSuccess,
    updateDepartmentError,

    deleteDepartmentRequest,
    deleteDepartmentSuccess,
    deleteDepartmentError,

    createSubDepartmentRequest,
    createSubDepartmentSuccess,
    createSubDepartmentError,

    getSubDepartmentRequest,
    getSubDepartmentSuccess,
    getSubDepartmentError,

    getAllSubDepartmentListRequest,
    getAllSubDepartmentListSuccess,
    getAllSubDepartmentListError,

    getSubDepartmentByDepartmentRequest,
    getSubDepartmentByDepartmentSuccess,
    getSubDepartmentByDepartmentError,

    updateSubDepartmentRequest,
    updateSubDepartmentSuccess,
    updateSubDepartmentError,

    createProjectRequest,
    createProjectSuccess,
    createProjectError,

    getProjectRequest,
    getProjectSuccess,
    getProjectError,

    getAllProjectListRequest,
    getAllProjectListSuccess,
    getAllProjectListError,

    updateProjectRequest,
    updateProjectSuccess,
    updateProjectError,

    createSkillRequest,
    createSkillSuccess,
    createSkillError,

    getSkillRequest,
    getSkillSuccess,
    getSkillError,

    getAllSkillListRequest,
    getAllSkillListSuccess,
    getAllSkillListError,

    updateSkillRequest,
    updateSkillSuccess,
    updateSkillError,

    assignProjectRequest,
    assignProjectSuccess,
    assignProjectError,

    getAssignProjectRequest,
    getAssignProjectSuccess,
    getAssignProjectError,

    assignSkillRequest,
    assignSkillSuccess,
    assignSkillError,

    getAssignSkillRequest,
    getAssignSkillSuccess,
    getAssignSkillError,

    addProjectTypeRequest,
    addProjectTypeSuccess,
    addProjectTypeError,

    updateProjectTypeRequest,
    updateProjectTypeSuccess,
    updateProjectTypeError,

    deleteProjectTypeRequest,
    deleteProjectTypeSuccess,
    deleteProjectTypeError,

    getProjectTypeRequest,
    getProjectTypeSuccess,
    getProjectTypeError,

    getAllProjectTypeListRequest,
    getAllProjectTypeListSuccess,
    getAllProjectTypeListError,

    addProjectCategoryRequest,
    addProjectCategorySuccess,
    addProjectCategoryError,

    updateProjectCategoryRequest,
    updateProjectCategorySuccess,
    updateProjectCategoryError,

    deleteProjectCategoryRequest,
    deleteProjectCategorySuccess,
    deleteProjectCategoryError,

    getProjectCategoryRequest,
    getProjectCategorySuccess,
    getProjectCategoryError,

    getAllProjectCategoryListRequest,
    getAllProjectCategoryListSuccess,
    getAllProjectCategoryListError,

    getMastersCountsRequest,
    getMastersCountsSuccess,
    getMastersCountsError,

    handleClearDepartmentStore,
    // toastMsgAction,

}